{
  "id": "campaign-030",
  "name": "Golden Promenade II",
  "seed": "campaign:30",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "......,.....",
    ".....,,.....",
    "............",
    "zzzzzz......",
    ".,,,hz.h....",
    ".#,n.z..n...",
    "...zzz......",
    "............",
    "sss........,",
    "sss.......,,",
    "............",
    ",,..ww......",
    "____________",
    "............",
    ".T..T..T..T.",
    ".........x..",
    "...........S"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 4,
      "y": 2
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 7
    },
    {
      "kind": "squirrel",
      "x": 11,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 2,
      "y": 11
    },
    {
      "kind": "gas",
      "x": 7,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 2,
      "y": 9
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 16
    }
  ],
  "generatorVersion": 3,
  "level": 30,
  "biome": "park",
  "par": {
    "reel": 7572,
    "push": 6376,
    "selfPropelled": 5832,
    "tractor": 4460,
    "zeroTurn": 3800,
    "fairway": 2638
  },
  "routeTries": {
    "par": {
      "reel": 16,
      "push": 21,
      "selfPropelled": 16,
      "tractor": 0,
      "zeroTurn": 0,
      "fairway": 5
    }
  }
}
